import audioPlayer from '@motionelements/core/src/store/modules/audioPlayer.js';

export default {
  namespaced: true,
  state: () => audioPlayer.state,
  getters: audioPlayer.getters,
  actions: audioPlayer.actions,
  mutations: audioPlayer.mutations,
};
